class ModalResetpassword extends ModalDialog {
    constructor() {
        super();
        this.addEventListener('keydown', (event) => {
            if (event.key === 'Tab') {
                this.maintainFocus(this, event);
            }
        });
    }

    connectedCallback() {
     
    }

    show(opener) {
        super.show(opener);
        this.trapFocus(this);
    }

    trapFocus(modal) {
        const focusableElements = modal.querySelectorAll('a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])');
        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];
        
        modal.addEventListener('keydown', (event) => {
            if (event.key === 'Tab') {
                if (event.shiftKey) {
                    if (document.activeElement === firstElement) {
                        event.preventDefault();
                        lastElement.focus();
                    }
                } else {
                    if (document.activeElement === lastElement) {
                        event.preventDefault();
                        firstElement.focus();
                    }
                }
            }
        });
        firstElement.focus();
    }

    maintainFocus(modal, event) {
        const focusableElements = modal.querySelectorAll('a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])');
        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];
        
        if (event.shiftKey && document.activeElement === firstElement) {
            event.preventDefault();
            lastElement.focus();
        } else if (!event.shiftKey && document.activeElement === lastElement) {
            event.preventDefault();
            firstElement.focus();
        }
    }
}

customElements.define('modal-resetpassword', ModalResetpassword);

class ModalResetOpen extends ModalOpener { 
    constructor() {
        super();
        const button = this.querySelector('button');
        
        button.addEventListener('click', (event) => {
            event.preventDefault();
            const modal = document.querySelector(this.getAttribute('data-modal'));
            if (modal) modal.show(button);
        });

        // Handle keyboard Enter key
        button.addEventListener('keydown', (event) => {
            if (event.key === 'Enter') {
                event.preventDefault();
                const modal = document.querySelector(this.getAttribute('data-modal'));
                if (modal) modal.show(button); // Open the modal with the Enter key
            }
        });
    }
}

customElements.define('modal-reset-open', ModalResetOpen);